import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Features() {
  return (
    <section
      id="features"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 align-self-center">
            <p>
<b>УВАГА! БАГАТО ПОСТРАЖАЛИХ ВІД ЦЬОГО ШАХРАЯ:</b><br /><br />
Після спілкування у групах автозапчастин в Одесі, з'ясувалося, що я не єдиний постраждалий! Багато людей постраждали від дій Коломійця Івана, деякі зіткнулися на обмані під час ремонту автомобілів на його СТО, иншим він надіслав несправні запчастини та відмовився повертати кошти, частина людей постраждала тим, що після ремонту автомобіля їм було озвучено додаткову суму до оплати.<br /><br />
ВАЖЛИВО: Усю діяльність Колимієць Іван веде <font color="red"><b>НЕ ЗАКОННО</b></font>: не сплачує податки, гроші приймає без касового апарату, просто бере готівку або дає карти оформлені на дропів, щоб на них переказували гроші за розрахунком за ремонт авто та автозапчастини.
            </p>
          </div>
          <div className="col-lg-4 col-sm-12 align-self-center">
            <p>
<b>Відкриті насмишки з ошуканих людей публікує в себе в інстагграм Коломієць Іван.</b>
            </p>
          </div>
          <div className="col-lg-3 col-sm-12 text-center mb-4 mb-xl-0">
            <img
              alt=""
              src="images/image3.jpg"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-5 col-sm-12 align-self-center">
            <p>
<b>Національна Поліція України @police_ukraine , просимо зайнятися цим питанням, а саме виявити недобросовісних співробітників Поліції в Одеській Області, с.Нерубайське, які кришують афери шахрая Коломійця Івана. <br />
<a href="https://mvs.gov.ua/contacts/national-police-ukraine" target="_blank">https://mvs.gov.ua/contacts/national-police-ukraine</a></b>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
